import { render, staticRenderFns } from "./FlightModalGraphTwoAxes.vue?vue&type=template&id=0144570b&scoped=true"
import script from "./FlightModalGraphTwoAxes.vue?vue&type=script&lang=js"
export * from "./FlightModalGraphTwoAxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0144570b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
